import {FC} from "react";
import {TabColumn} from "../../../tab-content";
import "./OperationalDetailsColumn.scss";
import {useOperationalEntity} from "../../context";
import {OperationalBusinessInformation} from "./OperationalBusinessInformation";
import {OperationalDetailsHeader} from "./OperationalDetailsHeader";
import {Address, DealerStatusBar, Oems, Sources} from "../../overview";
import {DealerInformation} from "@common-core/coat-operational-hierarchy-appsync-model";

export const OperationalDetailsColumn: FC = () => {
  const {
    entity: {
      id,
      dealerInformation = {} as DealerInformation,
      oems,
      statuses = [],
      sources
    }
  } = useOperationalEntity();

  return (
    <TabColumn name={"details-column"} header={<OperationalDetailsHeader />}>
      <DealerStatusBar id={id} statuses={statuses} />
      <OperationalBusinessInformation />
      <Sources id={id} sources={sources} />
      <Address id={id} dealerInformation={dealerInformation} />
      <Oems id={id} oems={oems} />
    </TabColumn>
  );
};
